import {
  Component,
  Input,
  OnDestroy,
  inject,
  input,
  output,
  signal,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subject, Subscription, of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { LocationRepository } from "../../../location/location.repository";
import { AutoCompleteSelectEvent, AutoComplete } from "primeng/autocomplete";
import { IMaerskLocation } from "app/location/maersk-location.model";
import { CountrySelectComponent } from "../country-select/country-select.component";
import { AutocompleteEmptyMessageComponent } from "../autocomplete-empty-message/autocomplete-empty-message.component";
import { Bind } from "primeng/bind";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-maersk-location-select",
  styleUrls: ["./maersk-location-select.component.scss"],
  templateUrl: "./maersk-location-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CountrySelectComponent,
    Bind,
    AutoComplete,
    FormsModule,
    AutocompleteEmptyMessageComponent,
  ],
})
export class MaerskLocationSelectComponent implements OnDestroy {
  private locationRepository = inject(LocationRepository);

  public readonly locationChange = output<{
    country: string;
    location: IMaerskLocation;
  }>();
  @Input() public searchQuery: string;
  public readonly appendTo = input<any>("body");
  @Input() public country: string;

  public subscription = new Subscription();
  public locationList: IMaerskLocation[] = [];
  public location: IMaerskLocation;
  public readonly loading = signal(false);

  private searchTerm = new Subject<{ query: string; country: string }>();

  public constructor() {
    this.subscription.add(
      this.searchTerm
        .pipe(
          switchMap(({ query, country }) =>
            this.locationRepository
              .searchMaersk(query, country)
              .pipe(catchError(() => of(null))),
          ),
        )
        .subscribe((locations: IMaerskLocation[] | null) => {
          this.locationList = locations ?? [];
          for (const location of this.locationList) {
            if (location.UNRegionCode) {
              location.cityName += ", " + location.UNRegionCode;
            }
          }
          this.loading.set(false);
        }),
    );
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public onLocationChange(event: AutoCompleteSelectEvent) {
    if (event.value) {
      this.location = event.value;
      this.locationChange.emit({
        country: this.country,
        location: this.location,
      });
      this.searchQuery = "";
    } else {
      event.originalEvent.preventDefault();
      event.originalEvent.stopPropagation();
    }
  }

  public getPlaceholder() {
    if (this.location && !!this.location.cityName) {
      return this.location.cityName;
    }

    return "City name";
  }

  public search(event: { originalEvent: KeyboardEvent; query: string }): void {
    // new array reference opens the overlay so the loading message is visible
    this.locationList = [];
    this.loading.set(true);
    this.searchTerm.next({ query: event.query, country: this.country });
  }
}
